var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'p-1 d-flex align-items-center', {
      'bg-pale-danger': !_vm.isEmpty(_vm.event.extendedProps.deleted_at),
      'bg-pale-warning': _vm.isEmpty(_vm.event.extendedProps.deleted_at) && _vm.isEventUpdated,
    }
  ]},[_c('BAvatar',{attrs:{"text":String(_vm.event.extendedProps.new_number_of_activities),"variant":"outline-dark","size":"24"}}),_c('span',{class:[
      'mx-1 p-0 text-nowrap text-truncate text-dark font-weight-bolder'
    ],domProps:{"textContent":_vm._s(_vm.event.title)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }